import React from 'react';

import { Typography } from '@material-ui/core';
import Page from '../page/Page';

const DashboardPage = () => (
  <Page>
    <Typography variant="h2">Dashboard ~ TBD</Typography>
  </Page>
);

export default DashboardPage;
